import { Alert, Snackbar } from "@mui/material";
import { useState } from "react";

const withShowAlert = (Children) =>
  function WrapperComponent(props) {
    const [alertInfo, setAlertInfo] = useState({ message: '', severity: '', open: false });
    const showAlert = (message, severity) => {
      setAlertInfo({ message: message, severity: severity, open: true })
    }
    return <>
      <Snackbar
        open={alertInfo.open} anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{ zIndex: '9999999999999999999' }}
        autoHideDuration={6000} onClose={() => setAlertInfo({ ...alertInfo, open: false })}>
        <Alert onClose={() => setAlertInfo({ ...alertInfo, open: false })} severity={alertInfo.severity} sx={{ width: '100%' }}>
          {alertInfo.message}
        </Alert>
      </Snackbar>
      <Children {...props} showAlert={showAlert} />
    </>
  }

export default withShowAlert